const baseURL = 'https://rr-api.realisticrealtors.com'
export default baseURL
